module.exports = __webpack_public_path__ + "img/0e4582fad77f3775a8d772c9936f87d3.png";